import { useQuery } from "@tanstack/react-query";
import { errorText } from "@common/api";
import { admin, queryKeys, type DeployComponent } from "../../api/salvagers";

const WHAT: Record<DeployComponent, string> = {
  terraform: "Bucket, distribution, tables, Lambda and routes",
  api: "salvagers-api Lambda code",
  ui: "The site",
};

/** When each part of the app was last deployed, as deploy.sh recorded it. */
export default function Deploys() {
  const deploys = useQuery({ queryKey: queryKeys.deploys, queryFn: admin.deploys });
  return (
    <section>
      <h2>Deploys</h2>
      <p className="muted">
        The last <code>./deploy.sh</code> of each component, from the shared system-metadata table.
      </p>
      {deploys.error && <p className="notice error">{errorText(deploys.error, "Could not read the deploy times.")}</p>}
      {deploys.data && (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Component</th>
                <th>Deployed</th>
                <th>By</th>
              </tr>
            </thead>
            <tbody>
              {deploys.data.map((deploy) => (
                <tr key={deploy.component}>
                  <td>
                    <strong>{deploy.component}</strong> <span className="muted small">{WHAT[deploy.component]}</span>
                  </td>
                  <td>
                    {deploy.deployed_at ? (
                      <time dateTime={deploy.deployed_at}>{new Date(deploy.deployed_at).toLocaleString()}</time>
                    ) : (
                      <span className="muted">Never</span>
                    )}
                  </td>
                  <td>{deploy.deployed_by ?? ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
